
const roles = {
	main: {
		CITIZEN: 1000,
		PENDING_CITIZEN: 1001,
		VERIFIED_CITIZEN: 1002,
		ENTITY: 9000,
		EBOARD: 10000
	}
}

class User {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.id = jsonData.id;
		this.email = jsonData.email;
		this.firebaseId = jsonData.firebaseId;
		this.installationId = jsonData.installationId;
		this.role = jsonData.role;
		this.additionalRoles = jsonData.additionalRoles;

		if (jsonData.userProfile) {
			this.userProfile = new CitizenProfile(jsonData.userProfile);
		}
	}

	isCitizen() {
		return this.role === roles.main.CITIZEN || 
			this.role === roles.main.PENDING_CITIZEN || 
			this.role === roles.main.VERIFIED_CITIZEN;
	}

	isEntity() {
		return this.role === roles.main.ENTITY;
	}

	isEboard() {
		return this.role === roles.main.EBOARD;
	}

	hasRole(roleId) {
		return this.role === roleId || this.additionalRoles.includes(roleId);
	}

}

class CitizenProfile {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.userId = jsonData.userId;
		this.name = jsonData.name;
		this.lastName = jsonData.lastName;
		this.phoneNumber = jsonData.phoneNumber;
		this.gender = jsonData.gender;
		this.educationLevel = jsonData.educationLevel;
		this.photoUrl = jsonData.photoUrl;
		this.birthDate = jsonData.birthDate;
	}

	getBirthDate() {
		return new Date(this.birthDate.year, this.birthDate.month-1, this.birthDate.day);
	}

	getGenderName() {
		if (this.gender === 0) 
			return "Hombre";
		else if (this.gender === 1) 
			return "Mujer"
		else
			return "Otro";
	}

	isMan() {
		return this.gender === 0;
	}

	isWoman() {
		return this.gender === 1;
	}

}


class Role {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.id = jsonData.id;
		this.name = jsonData.name;
		this.description = jsonData.description;
		this.mainRole = jsonData.mainRole;
		this.assignable = jsonData.assignable;
	}

}

export { User, Role, CitizenProfile }